import { writable } from 'svelte/store'
import { getOrgLibraryStatus, getMarketDataStatus } from 'services/api/apiCalls'

function createStatusState() {
  return {
    data: [],
    loading: false,
    loaded: false,
    error: false,
  }
}

const initialState = {
  ORGANIZATION_DATA: createStatusState(),
  MARKET_DATA: createStatusState(),
}

const statusLoaders = {
  ORGANIZATION_DATA: getOrgLibraryStatus,
  MARKET_DATA: getMarketDataStatus,
}

function createUploadStatusStore() {
  const { subscribe, set, update } = writable(initialState)

  return {
    subscribe,
    set,
    update,
    refetch: async dataSource => {
      const loader = statusLoaders[dataSource]

      if (!loader) {
        return []
      }

      update(store => ({
        ...store,
        [dataSource]: {
          ...store[dataSource],
          loading: true,
          error: false,
        },
      }))

      try {
        const data = await loader()
        const normalizedData = Array.isArray(data) ? data : []

        update(store => ({
          ...store,
          [dataSource]: {
            data: normalizedData,
            loading: false,
            loaded: true,
            error: !Array.isArray(data),
          },
        }))

        return normalizedData
      } catch (_error) {
        update(store => ({
          ...store,
          [dataSource]: {
            ...store[dataSource],
            loading: false,
            loaded: true,
            error: true,
          },
        }))

        return []
      }
    },
  }
}

export const uploadStatusStore = createUploadStatusStore()
